export enum EnumPartnerProductPortfolio {
  BENEFIT_CARDS_AND_HEALTH_PLANS = "Trabalha com cartões de benefícios e planos de saúde",
  HEALTH_PLANS = "Trabalha com planos de saúde",
  INTERNAL_PORTFOLIO = "Trabalha com portfólio Interno",
  NO_PORTFOLIO = "Sem portfólio",
}
